export const getFullMediaUrlFromPresignedUrl = (presignedUrl = '') => {
  if (!presignedUrl) {
    return null;
  }

  const urlWithoutQueryParams = presignedUrl.split('?')[0];
  return urlWithoutQueryParams;
};

export const getPathFromFullMediaUrl = (mediaUrl) => {
  // split by / and get the three last pieces of the array, and put them together
  const splitBySlash = mediaUrl.split('/');
  const splitLength = splitBySlash.length;
  const assetPath = `${splitBySlash[splitLength - 3]}/${splitBySlash[splitLength - 2]}/${
    splitBySlash[splitLength - 1]
  }`;

  return assetPath;
};



// WEBPACK FOOTER //
// ./src/utils/getFullMediaUrlFromPresignedUrl.js